import { RootReducerType } from "../CombineReducer";

export const useUserInfo = (state: RootReducerType) => state.auth.userInfo;
export const useUserError = (state: RootReducerType) => state.auth.error;
export const useLoginAuthenticating = (state: RootReducerType) => state.auth.isAuthenticating;
export const useUserLogined = (state: RootReducerType) => state.auth.isLogined;
export const useGetUserRole = (state: RootReducerType) => state.auth.userInfo?.userRole || "";

